import api from './api';

export default {
  getBBBProductTerms() {
    return new Promise((resolve, reject) => {
      api
        .get(`bbb-product-term`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
